import React, { useState, useEffect, useRef } from "react";
import { auth } from "../services/api";
const bg1 = "/images/bg_1.png";
const titleTop = "/images/title_top.png";
const titleBottom = "/images/title_bottom.png";

const SmsForm = ({ phone, onAuthSuccess }) => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleCodeChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 6) {
      setCode(value);
      setError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    setLoading(true);
    try {
      await auth(phone, code);
      setLoading(false);
      onAuthSuccess();
    } catch (err) {
      setLoading(false);
      setError(err.message || "Неверный код. Попробуйте еще раз");
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSubmit(e);
    }
  };

  return (
    <div className="wrapper">
      <div className="template">
        <div className="bg">
          <img src={bg1} alt="bg" />
        </div>
        <div className="title-top">
          <img src={titleTop} alt="title-top" />
        </div>
        <div className="title-bottom">
          <img src={titleBottom} alt="title-bottom" />
        </div>
      </div>

      <div className="container">
        <form className="form" onSubmit={handleSubmit}>
          <h2 className="title">Введите код из SMS сообщения</h2>

          <input
            ref={inputRef}
            type="text"
            className="input sms-input"
            placeholder="______"
            value={code}
            onChange={handleCodeChange}
            onKeyPress={handleKeyPress}
            maxLength={6}
            inputMode="numeric"
            disabled={loading}
          />

          <button type="submit" className="button" disabled={loading}>
            {loading ? "Проверка..." : "Отправить"}
          </button>
        </form>
      </div>
      {error && (
        <div className="error-toast" onClick={() => setError("")}>
          {error}
        </div>
      )}
    </div>
  );
};

export default SmsForm;
